module.exports = __webpack_public_path__ + "img/tab_01_active.cafb4749.svg";